export default __webpack_public_path__ + "static/blob3-9ed88e7bce1be6e1f83bf18152afd2a9.svg";